import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import swal from "sweetalert";
import axios from "axios";
import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import MDInput from "admin/components/MDInput";
import DashboardLayout from "admin/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "admin/examples/Navbars/DashboardNavbar";

const API_URL = process.env.REACT_APP_APIHOST || "http://localhost:3033";
const COUNTRIES = ["Syria","Lebanon","Palestine","Jordan","Iraq","Yemen","Egypt","Saudi Arabia","UAE","Kuwait","Bahrain","Qatar","Oman","Turkey","Iran","Afghanistan","Pakistan","Libya","Tunisia","Algeria","Morocco","Sudan","Somalia","Mali","Niger","Burkina Faso","Nigeria","Chad","Mauritania","South Africa","Ethiopia","Kenya","Cameroon","DR Congo","Central African Republic","Mozambique","Senegal","Ivory Coast"];

function IntelPointsPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAdd, setShowAdd] = useState(false);
    const [editId, setEditId] = useState(null);
    const [form, setForm] = useState({ content: "", countries: [], date: "" });

    useEffect(() => { fetch(); }, []);

    const fetch = async () => {
        try {
            setLoading(true);
            const res = await axios.get(API_URL + "/intel-points");
            if (res.data.status) setItems(res.data.data);
        } catch(e) {} finally { setLoading(false); }
    };

    const openAdd = () => {
        const now = new Date();
        const pad = n => String(n).padStart(2,"0");
        setEditId(null);
        setForm({ content: "", countries: [], date: now.getFullYear()+"-"+pad(now.getMonth()+1)+"-"+pad(now.getDate())+"T"+pad(now.getHours())+":"+pad(now.getMinutes()) });
        setShowAdd(true);
    };

    const openEdit = (item) => {
        setEditId(item._id);
        setForm({ content: item.content || "", countries: item.countries || [], date: item.date ? new Date(item.date).toISOString().slice(0,16) : "" });
        setShowAdd(true);
    };

    const handleSave = async () => {
        if (!form.content) return;
        try {
            if (editId) {
                await axios.put(API_URL + "/intel-points/" + editId, form);
            } else {
                await axios.post(API_URL + "/intel-points", form);
            }
            setShowAdd(false); setEditId(null); fetch();
        } catch(e) { swal("Error", "Failed to save", "error"); }
    };

    const handleDelete = (id) => {
        swal({ title: "Delete?", icon: "warning", buttons: true, dangerMode: true }).then(async (ok) => {
            if (ok) { await axios.delete(API_URL + "/intel-points/" + id); fetch(); }
        });
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={2} pb={2}>
                <Card>
                    <MDBox px={2} pt={1} pb={0.5} display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="body2" sx={{ color: "#C29717", fontSize: "11px", textTransform: "uppercase", letterSpacing: "1.5px" }}>
                            Intel points ({items.length})
                        </MDTypography>
                        <MDTypography component="span" sx={{ color: "#aaa", fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", "&:hover": { color: "#fff" } }} onClick={openAdd}>
                            <Icon sx={{ fontSize: "14px !important" }}>add_circle_outline</Icon> Add
                        </MDTypography>
                    </MDBox>

                    {showAdd && (
                        <MDBox px={2} py={1.5} sx={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                            <Grid container spacing={1.5}>
                                <Grid item xs={12}>
                                    <MDInput type="text" label="Intel content *" fullWidth multiline rows={3} value={form.content} onChange={e => setForm({...form, content: e.target.value})} />
                                </Grid>
                                <Grid item xs={8}>
                                    <Autocomplete multiple freeSolo options={COUNTRIES} value={form.countries}
                                        onChange={(_, v) => setForm({...form, countries: v})}
                                        renderTags={(val, getTagProps) => val.map((co, i) => {
                                            const { onDelete } = getTagProps({ index: i });
                                            return <span key={co} style={{display:'inline-flex',alignItems:'center',gap:'4px',background:'rgba(194,151,23,0.15)',border:'1px solid rgba(194,151,23,0.3)',borderRadius:'2px',padding:'2px 8px',fontSize:'11px',color:'#fff',margin:'2px'}}>{co}<span style={{cursor:'pointer',color:'#C29717',fontSize:'14px'}} onClick={onDelete}>&times;</span></span>;
                                        })}
                                        renderInput={(params) => <TextField {...params} label="Countries" variant="outlined" size="small" />} />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField type="datetime-local" label="Date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} variant="outlined" fullWidth size="small" InputLabelProps={{ shrink: true }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <MDBox display="flex" gap={1}>
                                        <span onClick={handleSave} style={{padding:'5px 14px',background:'rgba(194,151,23,0.15)',border:'1px solid rgba(194,151,23,0.3)',borderRadius:'2px',color:'#C29717',fontSize:'11px',cursor:'pointer'}}>Save</span>
                                        <span onClick={() => { setShowAdd(false); setEditId(null); }} style={{padding:'5px 14px',border:'1px solid rgba(255,255,255,0.12)',borderRadius:'2px',color:'#888',fontSize:'11px',cursor:'pointer'}}>Cancel</span>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </MDBox>
                    )}

                    <MDBox px={2} py={1}>
                        {loading ? (
                            <MDBox display="flex" justifyContent="center" p={3}><div className="forte-spin" style={{margin:"0 auto"}}></div></MDBox>
                        ) : items.length === 0 ? (
                            <MDTypography sx={{ color: "#888", fontSize: "13px", py: 2, textAlign: "center" }}>No intel points yet</MDTypography>
                        ) : items.map(item => (
                            <MDBox key={item._id} sx={{ borderBottom: "1px solid rgba(255,255,255,0.04)", py: 1.2, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                <MDBox sx={{ flex: 1, minWidth: 0 }}>
                                    <MDTypography sx={{ color: "#fff", fontSize: "13px", mb: 0.3, lineHeight: 1.5 }}>{item.content}</MDTypography>
                                    <MDBox display="flex" gap={0.5} flexWrap="wrap" alignItems="center">
                                        {(item.countries||[]).map(co => <span key={co} style={{fontSize:'9px',color:'#C29717',background:'rgba(194,151,23,0.1)',border:'1px solid rgba(194,151,23,0.15)',borderRadius:'2px',padding:'0 5px'}}>{co}</span>)}
                                        <span style={{fontSize:'10px',color:'#666',marginLeft:'4px'}}>{item.date ? new Date(item.date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : ""}</span>
                                    </MDBox>
                                </MDBox>
                                <MDBox display="flex" gap={0.8} flexShrink={0} ml={1}>
                                    <Icon sx={{ fontSize: "14px !important", color: "#888", cursor: "pointer", "&:hover": { color: "#fff" } }} onClick={() => openEdit(item)}>edit</Icon>
                                    <Icon sx={{ fontSize: "14px !important", color: "#888", cursor: "pointer", "&:hover": { color: "#e55" } }} onClick={() => handleDelete(item._id)}>delete</Icon>
                                </MDBox>
                            </MDBox>
                        ))}
                    </MDBox>
                </Card>
            </MDBox>
        </DashboardLayout>
    );
}

export default IntelPointsPage;
